import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Box, Grid, IconButton } from '@mui/material';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';

const SortableItem = (props) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable({ id: props.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    width: "180px",
    height: "94px",
    backgroundColor: "#cccccc",
    margin: "10px",
    borderRadius: "5px",
    zIndex: isDragging ? "100" : "auto",
    opacity: isDragging ? 0.3 : 1,
    display: "flex",
    justifyContent: "flex-end"
  };

  return (
    <Grid ref={setNodeRef} style={style}>
        <IconButton onClick={()=> props.handleDelete(props.value.id)} style={{ position: "absolute"}} aria-label="delete">
            <HighlightOffIcon />
        </IconButton>
      <Box>
        <Grid
            {...listeners} {...attributes}
          style={{
            minWidth: "30px",
            minHeight: "94px",
          }}
        >
          <img src={props.value.img_fullPath} alt={props.value.title}/>
          
        </Grid>
      </Box>
    </Grid>
  );
};

export default SortableItem;
